import { Col, Row, Alert, notification } from 'antd';
import * as React from 'react';
import { RouteProps } from 'react-router-dom';
import styled from 'styled-components';
import { HeaderRow, TitleCol, TitleColSize, PageTitle } from 'components/Styled/Layout.Styled';
import CenteredPageContainer from 'components/Layout/CenteredPageContainer';
import ArrivalScheduleForm from 'components/Schedule/ArrivalSchedule/ArrivalScheduleForm/ArrivalScheduleForm';

export interface Props extends RouteProps {
  children?: React.ReactNode;
}

export interface State { }

const TallCol = styled(Col)`
  height: 100%;
  min-height: 200px;
`;

export default class ArrivalSchedulePage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <CenteredPageContainer title="Vessel Schedule">
        <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px 50px", marginTop: "5px" }}>
          <ArrivalScheduleForm />
        </Row>
      </CenteredPageContainer>
    );
  }
}